import { AfterViewInit, Component, OnChanges, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { Subscription } from 'rxjs'
import Swal from 'sweetalert2'
import { ApiService } from '../api.service'
import { User } from '../types/user'
import { Organization } from '../types/organization'
import { Role } from '../types/role'

@Component({
	selector: 'users',
	templateUrl: './users.component.html',
	styleUrls: ['./users.component.scss']
})

export class UsersComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	loading = true
	
	searchRole = 0
	searchOrg = 0
	searchName = ''
	users: User[] = []
	orgs: Organization[] = []
	roles: Role[] = []

	userFormDialog: HTMLDialogElement | null = null
	userFormGroup: FormGroup
	userFormPasswordVisible = false
	userFormLoading = false
	userFormSuccess = false
	userFormError = false

	getOrgsSub = new Subscription
	getRolesSub = new Subscription
	getUsersSub = new Subscription
	addUserSub = new Subscription
	editUserSub = new Subscription
	closeUserSub = new Subscription
	deleteUserSub = new Subscription

	constructor(private dataService: ApiService, private router: Router, private formBuilder: FormBuilder) {
		this.userFormGroup = this.formBuilder.group({
			id: 			[0, 	Validators.required],
			firstname: 		['', 	Validators.required],
			lastname: 		['', 	Validators.required],
			email: 			['', 	Validators.email],
			phone: 			['', 	Validators.pattern(/[0-9]{9}/)],
			organization: 	[0, 	[Validators.required, Validators.min(1)]],
			role: 			[0, 	[Validators.required, Validators.min(1)]],
			username: 		['', 	Validators.required],
			password: 		['', 	Validators.required],
			ai: 			[false, Validators.required],
		})
	}

	ngOnInit() {
		let currentUserID = this.dataService.getUserID()
		if (currentUserID != 1) {
			this.router.navigate(['/home'])
		}

		this.getOrgs()
		this.getRoles()
		this.getUsers()
		this.userFormReset()

		this.userFormDialog = document.getElementById('user-form-dialog') as HTMLDialogElement
	}

	ngAfterViewInit() {
		
	}

	ngOnChanges() {
		
	}

	ngOnDestroy() {
		this.getOrgsSub?.unsubscribe()
		this.getRolesSub?.unsubscribe()
		this.getUsersSub?.unsubscribe()
		this.addUserSub?.unsubscribe()
		this.editUserSub?.unsubscribe()
		this.closeUserSub?.unsubscribe()
		this.deleteUserSub?.unsubscribe()
	}

	getOrgs() {
		this.getOrgsSub = this.dataService.getOrganizations()
		.subscribe(
			orgs => {
				this.orgs = orgs
			},
			error => {
				console.log(error)
			},
		)
	}

	getRoles() {
		this.getRolesSub = this.dataService.getRoles()
		.subscribe(
			roles => {
				this.roles = roles
			},
			error => {
				console.log(error)
			},
		)
	}

	getUsers(org: number = 0, role: number = 0, name: string = '') {
		this.getUsersSub = this.dataService.getUsers(org, role, name)
		.subscribe(
			users => {
				// console.log(users)
				this.loading = false
				this.users = users
			},
			error => {
				console.log(error)
			},
		)
	}

	userFormReset() {
		// this.userFormGroup.reset()
		this.userFormGroup.reset({
			id: 0,
			firstname: '',
			lastname: '',
			email: '',
			phone: '',
			organization: 0,
			role: 0,
			username: '',
			password: '',
			ai: false,
		})
	}

	userFormSetUser(user: User) {
		// console.log(user)
		this.userFormGroup.patchValue({
			id: user.id,
			firstname: user.firstname,
			lastname: user.lastname,
			email: user.email,
			phone: user.phone,
			organization: user.organization.id,
			role: user.role.id,
			username: user.username,
			password: user.password_visible,
			ai: user.ai,
		})
	}

	userFormShow(user: User | undefined = undefined) {
		if (user != undefined) {
			this.userFormSetUser(user)
		}

		this.userFormDialog?.showModal()

		return false
	}

	userFormClose() {
		this.userFormReset()
		this.userFormDialog?.close()

		return false
	}

	userFormTogglePasswordVisible() {
		this.userFormPasswordVisible = !this.userFormPasswordVisible
	}

	userFormSubmit() {
		console.log(this.userFormGroup)
		if (!this.userFormGroup.valid) return

		let formUserID = this.userFormGroup.value.id
		let formUser = new User()
		formUser.id = formUserID
		formUser.firstname = this.userFormGroup.value.firstname
		formUser.lastname = this.userFormGroup.value.lastname
		formUser.email = this.userFormGroup.value.email
		formUser.phone = this.userFormGroup.value.phone
		formUser.organization.id = this.userFormGroup.value.organization
		formUser.role.id = this.userFormGroup.value.role
		formUser.username = this.userFormGroup.value.username
		formUser.password_visible = this.userFormGroup.value.password
		formUser.ai = this.userFormGroup.value.ai

		this.userFormLoading = true
		this.userFormSuccess = false
		this.userFormError = false

		if (formUserID == 0) {
			// console.log('add')
			// console.log(formUser)

			this.addUserSub = this.dataService.addUser(formUser)
			.subscribe(
				res => {
					console.log(res)
					this.userFormLoading = false
					this.userFormSuccess = true
					this.userFormError = false
					
					setTimeout(() => {
						// this.userFormReset()
						// this.getUsers(this.searchOrg, this.searchRole)
						window.location.reload()
					}, 2000)
				},
				error => {
					console.log(error)
					this.userFormLoading = false
					this.userFormSuccess = false
					this.userFormError = true
				},
			)
		} else {
			// console.log('edit')
			// console.log(formUser)

			this.editUserSub = this.dataService.editUser(formUser)
			.subscribe(
				res => {
					console.log(res)
					this.userFormLoading = false
					this.userFormSuccess = true
					this.userFormError = false
					
					setTimeout(() => {
						// this.userFormReset()
						// this.getUsers(this.searchOrg, this.searchRole)
						window.location.reload()
					}, 2000)
				},
				error => {
					console.log(error)
					this.userFormLoading = false
					this.userFormSuccess = false
					this.userFormError = true
				},
			)
		}
	}

	closeUser(user: User) {
		let id = user.id
		if (id == 1) {
			Swal.fire({
				title: 'Error',
				text: 'No se puede cerrar el acceso al usuario administrador.',
				icon: 'error',
			})

			return false
		}

		let closed = user.closed
		closed = !closed
		
		this.closeUserSub = this.dataService.closeUser(id, closed)
		.subscribe(
			res => {
				console.log(res)
				user.closed = closed
			},
			error => {
				console.log(error)
			},
		)

		return false
	}

	/*
	showUserCoursePermissions(userID: any) {
		this.hideAll()
		this.userCoursePermissionsAdmin = true

		this.getUserCoursePermissionsSub = this.dataService.getUserCoursePermissions(userID)
		.subscribe(
			data => {
				console.log(data)
				this.userCoursePermissions = data
			},
			error => {
				console.log(error)
			},
		)

		return false
	}
	*/

	deleteUser(userID: any) {
		if (userID == 1) {
			Swal.fire({
				title: 'Error',
				text: 'No se puede eliminar al usuario administrador.',
				icon: 'error',
			})
			return false
		}

		Swal.fire({
			title: '¿Seguro?',
			text: '¿Está seguro que desea eliminar este usuario?',
			icon: 'question',
			showCancelButton: true,
			cancelButtonText: 'Cancelar'
		}).then((result) => {
			// console.log(result)
			if (!result.isConfirmed) return

			this.deleteUserSub = this.dataService.deleteUser(userID)
			.subscribe(
				res => {
					console.log(res)

					Swal.fire({
						title: 'Listo',
						text: '¡Usuario eliminado correctamente!',
						icon: 'success',
					})

					this.getUsers(this.searchOrg, this.searchRole)
				},
				error => {
					console.log(error)
				},
			)
		})

		return false
	}

}
